/**
 * @generated SignedSource<<918ac15a10aa7e14b8b6345d6abced26>>
 * @relayHash f8e577ec714260235e2a23b5c0b0c6ec
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8e577ec714260235e2a23b5c0b0c6ec

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type UserBlockDuration = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "PERMANENT" | "THREE_DAYS" | "%future added value";
export type IssueViewerSubscriptionTimelineSubscription$variables = {
  connections: ReadonlyArray<string>;
  issueId: string;
  skip?: number | null | undefined;
};
export type IssueViewerSubscriptionTimelineSubscription$data = {
  readonly issueUpdated: {
    readonly issueTimelineUpdated: {
      readonly timelineItems: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly __id: string;
            readonly actor?: {
              readonly __typename: string;
              readonly avatarUrl: string;
              readonly displayName?: string;
              readonly isAgent?: boolean;
              readonly isCopilot?: boolean;
              readonly login: string;
              readonly name?: string | null | undefined;
              readonly profileResourcePath: string | null | undefined;
            } | null | undefined;
            readonly assignee?: {
              readonly __typename: "Bot";
              readonly displayName?: string;
              readonly isAgent?: boolean;
              readonly isCopilot?: boolean;
              readonly login?: string;
              readonly name?: string | null | undefined;
              readonly resourcePath?: string;
            } | null | undefined;
            readonly blockDuration?: UserBlockDuration;
            readonly blockedIssue?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly blockedUser?: {
              readonly login: string;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly blockingIssue?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly canonical?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly closer?: {
              readonly __typename: "Commit";
              readonly abbreviatedOid: string;
              readonly repository: {
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | {
              readonly __typename: "ProjectV2";
              readonly title: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly closingProjectItemStatus?: string | null | undefined;
            readonly color?: string | null | undefined;
            readonly commit?: {
              readonly abbreviatedOid: string;
              readonly message: string;
              readonly messageBodyHTML: string;
              readonly messageHeadlineHTML: string;
              readonly repository: {
                readonly defaultBranch: string;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | null | undefined;
            readonly createdAt?: string;
            readonly currentTitle?: string;
            readonly databaseId?: number | null | undefined;
            readonly deletedCommentAuthor?: {
              readonly __typename: string;
              readonly login: string;
              readonly name?: string | null | undefined;
            } | null | undefined;
            readonly discussion?: {
              readonly number: number;
              readonly url: string;
            } | null | undefined;
            readonly duplicate?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly duplicateOf?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly fromRepository?: {
              readonly nameWithOwner: string;
              readonly url: string;
            } | null | undefined;
            readonly id?: string;
            readonly innerSource?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly intent?: {
              readonly rationale: string | null | undefined;
            } | null | undefined;
            readonly isCanonicalOfClosedDuplicate?: boolean | null | undefined;
            readonly issueComment?: {
              readonly databaseId: number | null | undefined;
              readonly url: string;
            } | null | undefined;
            readonly issueField?: {
              readonly dataType?: IssueFieldDataType;
              readonly name?: string;
            } | null | undefined;
            readonly issueType?: {
              readonly color: IssueTypeColor;
              readonly name: string;
            } | null | undefined;
            readonly label?: {
              readonly color: string;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly name: string;
              readonly nameHTML: string;
            };
            readonly lockReason?: LockReason | null | undefined;
            readonly milestone?: {
              readonly url: string;
            } | null | undefined;
            readonly milestoneTitle?: string;
            readonly newColor?: string | null | undefined;
            readonly newOptions?: ReadonlyArray<{
              readonly color: string | null | undefined;
              readonly name: string;
            }> | null | undefined;
            readonly newValue?: string | null | undefined;
            readonly options?: ReadonlyArray<{
              readonly color: string | null | undefined;
              readonly name: string;
            }> | null | undefined;
            readonly parent?: {
              readonly __typename: "Issue";
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly prevIssueType?: {
              readonly color: IssueTypeColor;
              readonly name: string;
            } | null | undefined;
            readonly previousStatus?: string;
            readonly previousTitle?: string;
            readonly project?: {
              readonly title: string;
              readonly url: string;
            } | null | undefined;
            readonly reactionGroups?: ReadonlyArray<{
              readonly content: ReactionContent;
              readonly reactors: {
                readonly nodes: ReadonlyArray<{
                  readonly __typename: "Bot";
                  readonly displayName: string;
                  readonly isAgent: boolean;
                  readonly isCopilot: boolean;
                  readonly login: string;
                } | {
                  readonly __typename: "Mannequin";
                  readonly login: string;
                } | {
                  readonly __typename: "Organization";
                  readonly login: string;
                } | {
                  readonly __typename: "User";
                  readonly login: string;
                } | {
                  // This will never be '%other', but we need some
                  // value in case none of the concrete values match.
                  readonly __typename: "%other";
                } | null | undefined> | null | undefined;
                readonly totalCount: number;
              };
              readonly viewerHasReacted: boolean;
            }> | null | undefined;
            readonly referencedAt?: string;
            readonly stateReason?: IssueStateReason | null | undefined;
            readonly status?: string;
            readonly subIssue?: {
              readonly __typename: "Issue";
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly subject?: {
              readonly __typename: "PullRequest";
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly repository: {
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly title: string;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly value?: string | null | undefined;
            readonly viewerCanUndo?: boolean;
            readonly willCloseSubject?: boolean;
            readonly willCloseTarget?: boolean;
            readonly " $fragmentSpreads": FragmentRefs<"IssueComment_issueComment">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number;
      };
    } | null | undefined;
  };
};
export type IssueViewerSubscriptionTimelineSubscription = {
  response: IssueViewerSubscriptionTimelineSubscription$data;
  variables: IssueViewerSubscriptionTimelineSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Variable",
    "name": "skip",
    "variableName": "skip"
  },
  {
    "kind": "Literal",
    "name": "visibleEventsOnly",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "User",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v6/*: any*/),
    (v15/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v21/*: any*/)
],
v23 = [
  (v8/*: any*/),
  (v7/*: any*/),
  (v21/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasReacted",
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v27 = [
  (v10/*: any*/)
],
v28 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "User",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v16/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v44 = [
  (v6/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v32/*: any*/),
      (v39/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v33/*: any*/),
      (v40/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v39/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingProjectItemStatus",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/),
    (v46/*: any*/)
  ],
  "type": "ProjectV2",
  "abstractKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v38/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockReason",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v16/*: any*/),
    (v52/*: any*/),
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentTitle",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousTitle",
  "storageKey": null
},
v56 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v58 = [
  (v6/*: any*/),
  (v10/*: any*/),
  (v57/*: any*/),
  (v16/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v58/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v58/*: any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        (v10/*: any*/),
        (v57/*: any*/)
      ],
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        (v10/*: any*/),
        (v57/*: any*/),
        (v12/*: any*/),
        (v14/*: any*/),
        (v13/*: any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockDuration",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referencedAt",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseTarget",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "milestoneTitle",
  "storageKey": null
},
v64 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v21/*: any*/),
  (v63/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v35/*: any*/)
    ],
    "storageKey": null
  }
],
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseSubject",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageHeadlineHTML",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageBodyHTML",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultBranch",
  "storageKey": null
},
v70 = [
  (v7/*: any*/),
  (v21/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v46/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v49/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v72 = [
  (v6/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v32/*: any*/),
  (v39/*: any*/)
],
v73 = [
  {
    "kind": "InlineFragment",
    "selections": (v72/*: any*/),
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v33/*: any*/),
      (v40/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v39/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUndo",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousStatus",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v80 = [
  (v6/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v32/*: any*/),
  (v39/*: any*/),
  (v7/*: any*/)
],
v81 = [
  (v7/*: any*/),
  (v21/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v80/*: any*/),
    "storageKey": null
  }
],
v82 = [
  (v7/*: any*/),
  (v21/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v80/*: any*/),
    "storageKey": null
  }
],
v83 = [
  (v7/*: any*/),
  (v21/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v72/*: any*/),
    "storageKey": null
  }
],
v84 = [
  (v7/*: any*/),
  (v21/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v72/*: any*/),
    "storageKey": null
  }
],
v85 = [
  (v16/*: any*/),
  (v52/*: any*/)
],
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v85/*: any*/),
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    (v87/*: any*/),
    (v16/*: any*/)
  ],
  "type": "IssueFieldText",
  "abstractKey": null
},
v89 = [
  (v16/*: any*/),
  (v87/*: any*/)
],
v90 = {
  "kind": "InlineFragment",
  "selections": (v89/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": (v89/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v92 = {
  "kind": "InlineFragment",
  "selections": (v89/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v93 = {
  "kind": "InlineFragment",
  "selections": (v89/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v88/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/)
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newColor",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "newOptions",
  "plural": true,
  "selections": (v85/*: any*/),
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newValue",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": (v85/*: any*/),
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v100 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v35/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  }
],
v101 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v6/*: any*/),
    (v15/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v103 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v102/*: any*/)
],
v104 = [
  (v8/*: any*/),
  (v7/*: any*/),
  (v102/*: any*/)
],
v105 = [
  (v6/*: any*/),
  (v10/*: any*/),
  (v33/*: any*/)
],
v106 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "ReactionGroup",
  "kind": "LinkedField",
  "name": "reactionGroups",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": (v26/*: any*/),
      "concreteType": "ReactorConnection",
      "kind": "LinkedField",
      "name": "reactors",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/),
            (v31/*: any*/),
            (v106/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reactors(first:5)"
    }
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v105/*: any*/),
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v16/*: any*/),
    (v37/*: any*/),
    (v108/*: any*/)
  ],
  "storageKey": null
},
v110 = [
  (v6/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v32/*: any*/),
      (v109/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v33/*: any*/),
      (v40/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v109/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v106/*: any*/)
],
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v108/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v112 = [
  (v10/*: any*/),
  (v57/*: any*/),
  (v16/*: any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v56/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        (v57/*: any*/)
      ],
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        (v57/*: any*/),
        (v12/*: any*/),
        (v14/*: any*/),
        (v13/*: any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    },
    (v106/*: any*/)
  ],
  "storageKey": null
},
v114 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v102/*: any*/),
  (v63/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v35/*: any*/),
      (v33/*: any*/)
    ],
    "storageKey": null
  }
],
v115 = [
  (v7/*: any*/),
  (v102/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v46/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v111/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v106/*: any*/)
    ],
    "storageKey": null
  }
],
v116 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v110/*: any*/),
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v35/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v118 = [
  (v6/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v32/*: any*/),
  (v109/*: any*/),
  (v7/*: any*/)
],
v119 = [
  (v7/*: any*/),
  (v102/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v118/*: any*/),
    "storageKey": null
  }
],
v120 = [
  (v7/*: any*/),
  (v102/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v118/*: any*/),
    "storageKey": null
  }
],
v121 = [
  (v6/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v32/*: any*/),
  (v109/*: any*/)
],
v122 = [
  (v7/*: any*/),
  (v102/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v123 = [
  (v7/*: any*/),
  (v102/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v124 = [
  (v16/*: any*/),
  (v52/*: any*/),
  (v33/*: any*/)
],
v125 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v124/*: any*/),
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v88/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v106/*: any*/)
  ],
  "storageKey": null
},
v127 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v102/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v35/*: any*/),
      (v7/*: any*/),
      (v33/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTimelineUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "SubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "UnsubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "MentionedEvent",
                            "abstractKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IssueComment_issueComment"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReactionGroup",
                                "kind": "LinkedField",
                                "name": "reactionGroups",
                                "plural": true,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v26/*: any*/),
                                    "concreteType": "ReactorConnection",
                                    "kind": "LinkedField",
                                    "name": "reactors",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v30/*: any*/),
                                          (v31/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "reactors(first:5)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v44/*: any*/),
                                "storageKey": null
                              },
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v47/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v35/*: any*/),
                                      (v36/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v33/*: any*/),
                                          (v16/*: any*/),
                                          (v38/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v35/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "ReopenedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v51/*: any*/),
                              (v21/*: any*/)
                            ],
                            "type": "LockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "UnlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "PinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "UnpinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v53/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "LabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/)
                            ],
                            "type": "RenamedTitleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v53/*: any*/)
                            ],
                            "type": "UnlabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v59/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v59/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v60/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v44/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v64/*: any*/),
                            "type": "MilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v64/*: any*/),
                            "type": "DemilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              (v7/*: any*/),
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v66/*: any*/),
                                  (v67/*: any*/),
                                  (v68/*: any*/),
                                  (v35/*: any*/),
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v38/*: any*/),
                                      (v69/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v70/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v71/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v70/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v21/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v73/*: any*/),
                                "storageKey": null
                              },
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v7/*: any*/),
                              (v76/*: any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v7/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "actor",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v6/*: any*/),
                                  (v15/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v77/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v21/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "ConvertedFromDraftEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v81/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v81/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v82/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v82/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v83/*: any*/),
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v83/*: any*/),
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v84/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v84/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v86/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v86/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v86/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v85/*: any*/),
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v94/*: any*/),
                              (v95/*: any*/),
                              (v96/*: any*/),
                              (v97/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v94/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v8/*: any*/),
                              (v94/*: any*/),
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v52/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*: any*/),
                            "type": "IssueCommentPinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*: any*/),
                            "type": "IssueCommentUnpinnedEvent",
                            "abstractKey": null
                          },
                          (v101/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTimelineUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "SubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "UnsubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "MentionedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              (v7/*: any*/),
                              (v35/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorAssociation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanDelete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanMinimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnminimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReport",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReportToMaintainer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanBlockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnblockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanPin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnpin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v35/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minimizedReason",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSpammyBadge",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdViaEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerDidAuthor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReadUserContentEdits",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastEditedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v35/*: any*/),
                                      (v10/*: any*/),
                                      (v33/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarUrl",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v6/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "locked",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v105/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "unfurlReferences",
                                    "value": true
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "bodyHTML",
                                "storageKey": "bodyHTML(unfurlReferences:true)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bodyVersion",
                                "storageKey": null
                              },
                              {
                                "alias": "isHidden",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMinimized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUpdate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v33/*: any*/),
                                      (v10/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v37/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewerCanCreateIssues",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slashCommandsEnabled",
                                    "storageKey": null
                                  },
                                  (v71/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingBlock",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingUnblock",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingMinimizeReason",
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v107/*: any*/)
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v107/*: any*/)
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v110/*: any*/),
                                "storageKey": null
                              },
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v47/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v35/*: any*/),
                                      (v36/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v33/*: any*/),
                                          (v16/*: any*/),
                                          (v108/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v35/*: any*/),
                                      (v48/*: any*/),
                                      (v111/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  },
                                  (v106/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v102/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "ReopenedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v51/*: any*/),
                              (v102/*: any*/)
                            ],
                            "type": "LockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "UnlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "PinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "UnpinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v53/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "LabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/)
                            ],
                            "type": "RenamedTitleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v53/*: any*/)
                            ],
                            "type": "UnlabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v113/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v113/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v102/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v19/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v60/*: any*/),
                              (v102/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v110/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v114/*: any*/),
                            "type": "MilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v114/*: any*/),
                            "type": "DemilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              (v7/*: any*/),
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v102/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v66/*: any*/),
                                  (v67/*: any*/),
                                  (v68/*: any*/),
                                  (v35/*: any*/),
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v108/*: any*/),
                                      (v69/*: any*/),
                                      (v33/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v115/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v71/*: any*/),
                                  (v35/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v115/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v102/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v110/*: any*/),
                                "storageKey": null
                              },
                              (v116/*: any*/),
                              (v75/*: any*/),
                              (v7/*: any*/),
                              (v76/*: any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v116/*: any*/),
                              (v75/*: any*/),
                              (v7/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "actor",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v6/*: any*/),
                                  (v15/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v117/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v117/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v102/*: any*/),
                              (v117/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v103/*: any*/),
                            "type": "ConvertedFromDraftEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v119/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v119/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v120/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v120/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v122/*: any*/),
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v122/*: any*/),
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v123/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v123/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v125/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v125/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v125/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v124/*: any*/),
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v126/*: any*/),
                              (v95/*: any*/),
                              (v96/*: any*/),
                              (v97/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v126/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v102/*: any*/),
                              (v8/*: any*/),
                              (v126/*: any*/),
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v52/*: any*/),
                              (v50/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v127/*: any*/),
                            "type": "IssueCommentPinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v127/*: any*/),
                            "type": "IssueCommentUnpinnedEvent",
                            "abstractKey": null
                          },
                          (v106/*: any*/),
                          (v101/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edges",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              (v33/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f8e577ec714260235e2a23b5c0b0c6ec",
    "metadata": {},
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "b8ac1f325839abd201a40d8fccb852d6";

export default node;
